import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotHighwayCamerasApiMeta } from "../apiMeta";
import {
  type HighwayCamerasByRouteAndMilepostInput,
  highwayCamerasByRouteAndMilepostInputSchema,
} from "./shared/cameras.input";
import { type Camera, cameraSchema } from "./shared/cameras.output";

/**
 * Metadata for the searchHighwayCamerasByRouteAndMilepost endpoint
 */
export const searchHighwayCamerasByRouteAndMilepostMeta = {
  functionName: "searchHighwayCamerasByRouteAndMilepost",
  endpoint: "/searchCamerasAsJson",
  inputSchema: highwayCamerasByRouteAndMilepostInputSchema,
  outputSchema: cameraSchema.array(),
  sampleParams: {
    StateRoute: "I-5",
    StartingMilepost: 10,
    EndingMilepost: 20,
  },
  endpointDescription: "Search cameras by route and milepost range.",
} satisfies EndpointMeta<HighwayCamerasByRouteAndMilepostInput, Camera[]>;

const { fetch, useHook } = createFetchAndHook<
  HighwayCamerasByRouteAndMilepostInput,
  Camera[]
>({
  api: wsdotHighwayCamerasApiMeta,
  endpoint: searchHighwayCamerasByRouteAndMilepostMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/cameras.endpoints").camerasGroup.cacheStrategy,
});

/**
 * Fetch function for searching cameras by route and milepost range
 */
export const searchHighwayCamerasByRouteAndMilepost: FetchFactory<
  HighwayCamerasByRouteAndMilepostInput,
  Camera[]
> = fetch;

/**
 * React Query hook for searching cameras by route and milepost range
 */
export const useSearchHighwayCamerasByRouteAndMilepost: HookFactory<
  HighwayCamerasByRouteAndMilepostInput,
  Camera[]
> = useHook;
